<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col style="width: 150px;">
            <el-input
              v-model="masterList.tableQuery.nickname"
              placeholder="用户微信昵称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col style="width: 150px;">
            <el-input
              v-model="masterList.tableQuery.appUserPhone"
              placeholder="用户联系电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col style="width: 180px;">
            <el-input
              v-model="masterList.tableQuery.certificateNo"
              placeholder="专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col style="width: 130px;">
            <el-select
              v-model="masterList.tableQuery.sourceType"
              clearable
              placeholder="成长值类型"
              style="width: 100%;"
              @keyup.enter.native="searchData()"
            >
              <el-option
                label="活动数据采集"
                :value="1"
              />
              <el-option
                label="调研问卷"
                :value="11"
              />
              <el-option
                label="陈列竞赛"
                :value="12"
              />
              <el-option
                label="图文分享"
                :value="13"
              />
              <el-option
                label="直播活动"
                :value="14"
              />
              <el-option
                label="兑换核销"
                :value="101"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.searchDate" />
          </el-col>
          <el-col :span="4">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-visible.sync="dialogViewVisible"
      :dialog-title="'查看'"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 日期选择
import DateSelect from '@/components/DateSelect';
// 查看
import viewDialog from './components/viewDialog'
// 数据请求
import { loadAppUserIntegralListDataApi, exportAppUserIntegralListDataApi } from '@/api/v2/appUserIntegral'

export default {
  name: 'AppUserIntegral',
  components: {
    CustomTable2,
    TableOperation2,
    DateSelect,
    viewDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_user_integral_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_user_integral_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['app_user_integral_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          nickName: '',
          appUserPhone: '',
          certificateNo: '',
          sourceType: '',
          searchData: '',
        }
      },
      id: null,
      dialogViewVisible: false,
      dialogImportVisible: false,
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'taui.province_name', width: 100 },
      { prop: 'wxId', label: '微信ID', filterColumn: "IFNULL(twcc.user_name, '')", width: 150 },
      { prop: 'wxOpenId', label: '小程序OPENID', filterColumn: "IFNULL(tau.wx_open_id, '')", width: 150 },
      { prop: 'questionnaireUid', label: '问卷用户ID', filterColumn: "IFNULL(tsqu.uid, '')", width: 150 },
      { prop: 'nickname', label: '微信昵称', filterColumn: "IFNULL(twcc.nickname, '')", width: 120 },
      { prop: 'appUserName', label: '姓名', filterColumn: "IFNULL(tau.name, '')", width: 100 },
      { prop: 'appUserPhone', label: '联系电话', filterColumn: "IFNULL(tau.phone, '')", width: 120 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: "IFNULL(tau.certificate_no, '')", width: 130 },
      { prop: 'storeName', label: '门店名称', filterColumn: "IFNULL(tau.store_name, '')", width: 150 },
      { prop: 'bxStoreNo', label: '本香门店码', filterColumn: "IFNULL(tau.benxiang_store_no, '')", width: 150 },
      { prop: 'sourceTypeValue', label: '类型', filterColumn: "(case taui.source_type when 1 then '活动数据采集' when 11 then '调研问卷' when 12 then '陈列竞赛' when 13 then '图文分享' when 14 then '直播活动' when 101 then '兑换核销' else '' end)", width: 100 },
      { prop: 'sourceName', label: '活动名称', filterColumn: 'taui.source_name', width: 200 },
      { prop: 'businessDate', label: '业务时间', filterColumn: 'taui.business_date', width: 150, isBetween: true },
      { prop: 'integralDate', label: '获取时间', filterColumn: 'taui.integral_date', width: 150, isBetween: true },
      { prop: 'integral', label: '成长值', filterColumn: 'taui.integral', width: 100 },
      { prop: 'remark', label: '备注', filterColumn: 'taui.remark', width: 150 },
      { prop: 'operatorName', filterColumn: 'taui.operator_name', label: '操作人', width: 90 },
      { prop: 'operationTime', filterColumn: 'taui.operation_time', label: '操作时间', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadAppUserIntegralListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 查看
    handleView (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: "请选择数据行", type: "warning" });
        return;
      } else if (args[0].sourceId === 0) {
        _this.$message({ message: "当前数据为导入数据，不能查看", type: "warning" });
        return;
      } else if (args[0].sourceType === 1) {
        _this.id = args[0].sourceId
        _this.dialogViewVisible = !_this.dialogViewVisible
      } else {
        _this.$message({ message: "其他类型的详细信息查看功能暂未开发", type: "error" });
        return;
      }
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportAppUserIntegralListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
